import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./combo_upsell_type.js";
//#region src/combo_upsell_type_helper.ts
var combo_upsell_type_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(type) {
	switch (type) {
		case "menu-item": return "Menu Item";
		case "combo-builder-mod-group": return "Combo Builder Mod Group";
	}
}
//#endregion
export { combo_upsell_type_helper_exports, name };

//# sourceMappingURL=combo_upsell_type_helper.js.map